/**
 * Punto di ingresso di compravendita e scambio su un portafoglio collegato a
 * un exchange crypto (SPEC-024 §9). Controparte di `ManualOrderButton`, che
 * resta per i broker: qui non ci sono ticker da mappare ne' posizioni da
 * scegliere — ci sono coppie e saldi, e li legge il modal dall'exchange.
 *
 * Compare solo se il portafoglio ha una connessione di tipo `crypto_exchange`
 * attiva **con gli ordini consentiti**: un exchange e' sempre su denaro reale,
 * quindi senza il flag del server il pulsante non c'e' — come per un broker
 * live — e la causa si cerca nella pagina Connessioni, non qui.
 */

import { useState } from 'react';
import { useConnections } from '@/features/connectors/api';
import { CryptoTradeModal } from '@/features/connectors/CryptoTradeModal';
import { Button } from '@/ui';

type Props = {
  portfolioId: string;
  /** Aperto da una posizione: l'asset e' gia' scelto. */
  fixedAsset?: string;
  defaultSide?: 'buy' | 'sell';
  label?: string;
};

export function CryptoTradeButton({ portfolioId, fixedAsset, defaultSide, label }: Props) {
  const connections = useConnections();
  const [open, setOpen] = useState(false);

  const connection = (connections.data?.items ?? []).find(
    (item) =>
      item.portfolio.id === portfolioId && item.kind === 'crypto_exchange' && item.status === 'active' && item.canPlaceOrders,
  );
  if (!connection) return null;

  return (
    <>
      <Button variant="secondary" onClick={() => setOpen(true)}>
        {label ?? 'Compra / Vendi / Scambia'}
      </Button>
      {open && (
        <CryptoTradeModal
          connectionId={connection.id}
          accountCurrency={connection.accountCurrency ?? 'EUR'}
          {...(fixedAsset ? { fixedAsset } : {})}
          {...(defaultSide ? { defaultSide } : {})}
          onClose={() => setOpen(false)}
        />
      )}
    </>
  );
}
